import { Schedule } from '../../../domain/schedule.model';

export namespace ScheduleAction {
    export class GetFlag {
        static readonly type = 'ScheduleAction.GetFlag';
    }

    export class GetAll {
        static readonly type = 'ScheduleAction.GetAll';
    }

    export class Save {
        static readonly type = 'ScheduleAction.Save';

        constructor(public schedule: Schedule) {
        }
    }

    export class Delete {
        static readonly type = 'ScheduleAction.Delete';

        constructor(public id: number) {
        }
    }

    export class OpenEditDialog {
        static readonly type = 'ScheduleAction.OpenEditDialog';

        constructor(public data: Schedule) {
        }
    }
}
